import { render, staticRenderFns } from "./historyAddress.vue?vue&type=template&id=b8c69ba8&scoped=true&"
import script from "./historyAddress.vue?vue&type=script&lang=js&"
export * from "./historyAddress.vue?vue&type=script&lang=js&"
import style0 from "./historyAddress.vue?vue&type=style&index=0&id=b8c69ba8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c69ba8",
  null
  
)

export default component.exports